document.addEventListener("click", function (e) {
  const button = e.target.closest('button[name="add"]');
  if (!button) return;

  const form = button.closest("form");
  if (!form || !form.action.includes("/cart/add")) return;

  const babyName = form.querySelector("#BabyName");
  if (!babyName) return; // only products with the field

  if (!babyName.value.trim()) {
    e.preventDefault();
    e.stopImmediatePropagation();
    babyName.focus();
    alert("Please enter the Custom Baby Name before adding to cart.");
  }
}, true);
